import React from 'react';
import { Mail, Phone, MapPin, User } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import { Section, FadeIn, PageHero } from '../components/ui-bits';
import Breadcrumb from '../components/Breadcrumb';

const Contacto = () => {
  const { t, lang } = useLanguage();

  return (
    <div data-testid="contact-page">
      <Breadcrumb items={[{ to: null, label: t.nav.contact }]} />
      <PageHero eyebrow={t.contact.eyebrow} title={t.contact.title} intro={t.contact.subtitle} />

      <Section className="pb-32">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <FadeIn>
            <a
              href="mailto:amgp2707@gmail.com"
              className="group block rounded-3xl border border-white/10 bg-white/[0.025] p-10 h-full card-hover"
              data-testid="contact-email-card"
            >
              <div className="w-12 h-12 rounded-2xl bg-amber-300/10 border border-amber-300/20 flex items-center justify-center text-amber-300">
                <Mail className="w-5 h-5" />
              </div>
              <div className="mt-6 text-xs uppercase tracking-[0.2em] text-amber-300/80">{t.contact.emailTitle}</div>
              <div className="mt-3 font-display text-2xl md:text-3xl text-white font-bold tracking-tight break-all">
                amgp2707@gmail.com
              </div>
            </a>
          </FadeIn>

          <FadeIn delay={0.08}>
            <a
              href="tel:+56222353000"
              className="group block rounded-3xl border border-white/10 bg-white/[0.025] p-10 h-full card-hover"
              data-testid="contact-phone-card"
            >
              <div className="w-12 h-12 rounded-2xl bg-amber-300/10 border border-amber-300/20 flex items-center justify-center text-amber-300">
                <Phone className="w-5 h-5" />
              </div>
              <div className="mt-6 text-xs uppercase tracking-[0.2em] text-amber-300/80">{t.contact.phoneTitle}</div>
              <div className="mt-3 font-display text-2xl md:text-3xl text-white font-bold tracking-tight">
                +56 2 2235 3000
              </div>
            </a>
          </FadeIn>

          <FadeIn delay={0.16}>
            <div className="rounded-3xl border border-white/10 bg-white/[0.025] p-10 h-full" data-testid="contact-address-card">
              <div className="w-12 h-12 rounded-2xl bg-amber-300/10 border border-amber-300/20 flex items-center justify-center text-amber-300">
                <MapPin className="w-5 h-5" />
              </div>
              <div className="mt-6 text-xs uppercase tracking-[0.2em] text-amber-300/80">{t.contact.addressTitle}</div>
              <div className="mt-3 font-display text-xl md:text-2xl text-white font-bold tracking-tight leading-tight">
                {t.contact.addressLine}
                <br />
                <span className="text-white/65 font-medium text-lg md:text-xl">{t.contact.addressCity}</span>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.24}>
            <div className="rounded-3xl border border-white/10 bg-white/[0.025] p-10 h-full" data-testid="contact-legal-card">
              <div className="w-12 h-12 rounded-2xl bg-amber-300/10 border border-amber-300/20 flex items-center justify-center text-amber-300">
                <User className="w-5 h-5" />
              </div>
              <div className="mt-6 text-xs uppercase tracking-[0.2em] text-amber-300/80">{t.contact.legalTitle}</div>
              <div className="mt-3 font-display text-2xl md:text-3xl text-white font-bold tracking-tight">
                {t.contact.legalName}
              </div>
              <div className="mt-3 text-white/55 text-sm font-body">Inversiones Tair SpA</div>
            </div>
          </FadeIn>
        </div>
      </Section>
    </div>
  );
};

export default Contacto;
